module.exports = __webpack_public_path__ + "static/media/workingmemory-words-2.411e43e5.mp3";